import {
  DocumentColumnWidths,
  useDocumentTableColumns,
} from '../../../../../hooks/useDocumentTableColumns';

const WORKSPACE_COLUMN_WIDTHS: DocumentColumnWidths = {
  code: '100px',
  title: '200px',
  type: '200px',
  owner: '150px',
  tags: '250px',
  version: '96px',
  status: '140px',
};

export const useWorkspaceTableColumns = () => {
  return useDocumentTableColumns({
    basePath: '/workspace',
    widths: WORKSPACE_COLUMN_WIDTHS,
    includeStatus: true,
  });
};
